import { render } from "./LayoutPublic.vue?vue&type=template&id=128f44dd"
import script from "./LayoutPublic.vue?vue&type=script&lang=js"
export * from "./LayoutPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__